import type React from 'react';

import { Separator } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { ShareContainer } from '../shareSunrise';
import { SignatureStatsActiveContainer } from '../stats/signatureStatsSunrise';

export const SideSignedNonPromotableContainer: React.FC = () => {
	return (
		<div className="flex flex-col gap-6">
			<SignatureStatsActiveContainer />
			<Separator orientation="horizontal" className="border-stroke-weak" />
			<h2 className="sr-only">
				<Translate value="fe.components.petition_share.action" />
			</h2>
			<ShareContainer forMobileView={false} />
		</div>
	);
};
